import type {
  FontAwesomeIconProps,
  IconDefinition,
} from '#src/atoms/icons/index.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';

type Props = {
  nickname: string | null;
  icon: IconDefinition;
  prefix?: string;
  color?: FontAwesomeIconProps['color'];
};

export const SocialUser = ({ nickname, icon, prefix = '', color }: Props) => {
  if (!nickname) return null;

  return (
    <Horizontal>
      <FontAwesomeIcon icon={icon} color={color} />
      {prefix}
      {nickname}
    </Horizontal>
  );
};
